<template>
  <div class="container mx-auto">
    <div class="flex flex-col sm:flex-row gap-3 mb-6 items-center" v-if="mode == 'cart'">
      <div class="flex-1 relative w-full">
        <i class="fa fa-search absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500 z-10"></i>
        <text-input placeholder="Buscar producto..." id="search" class="pl-12 pr-4 py-3 w-full border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors bg-white" v-model="form.search.terms" />
      </div>
      <div class="sm:w-64 relative w-full">
        <select v-model="form.search.category" class="w-full pl-4 pr-12 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none bg-white transition-colors">
          <option value="">Ver todas las categorías</option>
          <option v-for="category in product_categories" :key="category.id" :value="category.id">
            {{ category.name }}
          </option>
        </select>
        <i class="fa fa-chevron-down absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none z-10"></i>
      </div>
      <div class="flex items-center bg-white px-3.5 py-3 rounded-lg border border-gray-300 shadow-sm whitespace-nowrap">
        <label class="flex items-center text-xs font-bold text-gray-700 cursor-pointer select-none" title="Muestra solo productos que tienen stock disponible en esta tienda">
          <input
            type="checkbox"
            v-model="form.search.only_stock"
            class="w-4 h-4 text-blue-600 rounded border-gray-300 mr-2 focus:ring-blue-500 cursor-pointer"
          />
          <span>Solo con existencia</span>
        </label>
      </div>
      <div class="flex items-center gap-2">
        <button
          type="button"
          @click="showCashAdvanceModal = true"
          class="px-4 py-3 bg-amber-600 hover:bg-amber-700 text-white font-bold text-base rounded-lg shadow transition-all flex items-center justify-center cursor-pointer"
          title="Avance de Efectivo en Pesos (COP)"
        >
          <i class="fa fa-exchange-alt"></i>
        </button>

        <button
          type="button"
          @click="showWithdrawalModal = true"
          class="w-full sm:w-auto px-4 py-3 bg-red-600 hover:bg-red-700 text-white font-bold text-sm rounded-lg shadow transition-all flex items-center justify-center cursor-pointer whitespace-nowrap"
        >
          <i class="fa fa-hand-holding-usd mr-2"></i>
          <span>Retiro de Caja</span>
        </button>

        <button
          type="button"
          @click="showAuditModal = true"
          class="w-full sm:w-auto px-4 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-sm rounded-lg shadow transition-all flex items-center justify-center cursor-pointer whitespace-nowrap"
        >
          <i class="fa fa-calculator mr-2"></i>
          <span>Arqueo / Cierre</span>
        </button>
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3">
      <div class="col-span-2 mr-2 mb-20">
        <div v-if="mode == 'cart'" class="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 mb-20">
          <product-card v-for="product in products.data" :key="product.id" :product="product" @addCart="addCart" :change="change" :cop_change="cop_change" />
        </div>
      </div>

      <div v-if="mode == 'cart'" class="mb-4 px-6 py-4 bg-white rounded-lg shadow-lg">
        <h2 class="mb-4 text-lg font-bold text-gray-800 pb-2">Canasta</h2>

        <div v-if="!cart.length" class="text-center py-6 text-gray-500 text-sm">
          <i class="fa fa-shopping-cart text-2xl mb-2 text-gray-300"></i>
          <p>No hay productos en el carrito</p>
        </div>

        <div v-else class="space-y-3">
          <div v-for="(product, key) in cart" :key="product.id" class="flex items-center justify-between p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow border-l-4 border-l-blue-500">
            <div class="flex items-center flex-1">
              <button @click="removeProduct(product)" class="p-2 text-white bg-red-500 hover:bg-red-600 rounded-full shadow-sm transition-colors">
                <i class="fa fa-trash text-xs"></i>
              </button>
              <div class="ml-3">
                <h3 class="text-sm font-semibold text-gray-800">{{ product?.name }}</h3>
                <p class="text-gray-500 text-xs">{{ product?.stock }} Unidades Disponibles</p>
              </div>
            </div>
            <div class="flex flex-col items-end space-y-1 ml-3">
              <div class="flex items-center">
                <label class="text-sm font-bold mr-2">Cant:</label>
                <text-input-rounded :type="product?.is_decimal ? 'number' : 'number'" :step="product?.is_decimal ? '0.01' : '1'" :max="product?.stock" v-model="cart[key]['quantity']" @input="validateAndUpdateQuantity(product, key, $event)" class="border-2 border-gray-400 rounded px-2 py-1" />
              </div>
              <div class="text-right">
                <p class="text-xs font-medium text-gray-600">Precio: ${{ formatCurrency(cart[key]['price']) }} ({{formatCurrency(cart[key]['price_cop'])}})</p>
                <p class="text-sm font-bold text-gray-800">Total: ${{ formatCurrency(cart[key]['price'] * product.quantity) }} ({{formatCurrency(cart[key]['price_cop'] * product.quantity)}})</p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="cart.length" class="mt-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg shadow-md">
           <h3 class="text-sm font-bold text-gray-800 mb-2">Resumen de Totales</h3>
           <div class="space-y-2">
             <div class="flex items-center justify-between py-1">
               <span class="text-sm font-medium text-gray-700">Descuento</span>
               <select v-model="selectedDiscount" class="text-sm font-bold text-blue-600 border border-gray-300 rounded px-2">
                 <option value="0">0%</option>
                 <option value="1">1%</option>
                 <option value="2">2%</option>
                 <option value="3">3%</option>
                 <option value="4">4%</option>
                 <option value="5">5%</option>
                 <option value="6">6%</option>
               </select>
             </div>
             <div class="flex items-center justify-between py-1">
               <span class="text-sm font-medium text-gray-700"></span>
               <select v-model="selectedSurcharge" class="text-sm font-bold text-blue-600 border border-gray-300 rounded px-2">
                 <option value="0">0%</option>
                 <option value="1">1%</option>
                 <option value="2">2%</option>
                 <option value="3">3%</option>
                 <option value="4">4%</option>
                 <option value="5">5%</option>
                 <option value="6">6%</option>
                 <option value="custom">Personalizado</option>
               </select>
             </div>
             <div v-if="selectedSurcharge === 'custom'" class="flex items-center justify-between py-1">
               <span class="text-sm font-medium text-gray-700">(%)</span>
               <input type="number" v-model="customSurcharge" class="text-sm font-bold text-blue-600 border border-gray-300 rounded px-2" min="0" step="0.01" />
             </div>
             <div class="flex items-center justify-between py-1">
               <span class="text-sm font-medium text-gray-700">Total Descuento</span>
               <span class="text-sm font-bold text-red-600">${{ formatCurrency(getDiscountAmount()) }}</span>
             </div>
             <div class="flex items-center justify-between py-1">
               <span class="text-sm font-medium text-gray-700">Total USD</span>
               <span class="text-sm font-bold text-blue-600">${{ formatCurrency(getTotalWithDiscount()) }}</span>
             </div>
             <div class="flex items-center justify-between py-1">
               <span class="text-sm font-medium text-gray-700">Total Bs</span>
               <span class="text-sm font-bold text-blue-600">{{ formatCurrency(getTotalWithDiscount() * change) }}</span>
             </div>
             <div class="flex items-center justify-between py-1">
               <span class="text-sm font-medium text-gray-700">Total Cop</span>
               <span class="text-sm font-bold text-blue-600">{{ formatCurrency(getTotalCopWithDiscount()) }}</span>
             </div>
           </div>
         </div>

        <div class="mt-4 p-3 bg-gray-50 rounded shadow-sm">
          <label class="flex items-center space-x-2 cursor-pointer">
            <input type="checkbox" v-model="withoutClient" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500" />
            <span class="text-sm font-medium text-gray-700">Sin cliente?</span>
          </label>
        </div>
      </div>
      <div v-if="mode == 'client'" class="col-span-3 mb-4 px-8 py-6 bg-green-50 rounded-lg shadow-lg">
        <h2 class="mb-4 text-lg font-medium">Datos del cliente</h2>

        <div>
          <div class="flex flex-wrap mb-8 mr-6 p-8">
            <!-- <text-input v-model="form.client.companyName" label="Empresa" class="pb-8 pr-6 w-full lg:w-1/2" /> -->
            <div class="flex items-center pb-8 pr-6 w-full lg:w-1/2">
              <text-input v-model="form.client.identification" label="Alias" />
              <button class="btn-blue mt-5" @click="findClient" type="button"><i class="fa fa-search" /></button>
            </div>
            <text-input v-model="form.client.name" label="Nombre y Apellido de Cliente" class="pb-8 pr-6 w-full lg:w-1/2" />
            <!-- <text-input v-model="form.client.email" label="Email de Cliente" class="pb-8 pr-6 w-full lg:w-1/2" /> -->
            <!-- <text-input v-model="form.client.identification" label="Alias o Cédula de Cliente" class="pb-8 pr-6 w-full lg:w-1/2" /> -->
            <text-input v-model="form.client.phone" label="Telefono de Cliente" class="pb-8 pr-6 w-full lg:w-1/2" />
            <text-input v-model="form.client.address" label="Direccion de Cliente" class="pb-8 pr-6 w-full lg:w-1/2" />
            <text-input v-model="form.client.balance" disabled="true" label="Monto adeudado" class="pb-8 pr-6 w-full lg:w-1/2" />
            <div class="pb-8 pr-6 w-full lg:w-1/2">
              <label for="">Tipo de cliente</label>
              <select v-model="form.client.typeClient" class="form-input mt-2 w-full border-2 border-gray-600 rounded">
                <option value="">Seleccionar</option>
                <option value="freelancer">Freelancer</option>
                <option value="spot">SPOT</option>
                <option value="a">A</option>
                <option value="b">B</option>
                <option value="c">C</option>
              </select>
            </div>

            <!-- <label for="">Metodo de pago</label>
          <select v-model="form.method" class="form-input mt-2 w-full">
            <option value="">Seleccionar</option>
            <option value="efectivo">Efectivo</option>
            <option value="transferencia">Transferencia Bs</option>
            <option value="transferencia-usd">Transferencia Divisas</option>
            <option value="biopago">Zelle</option>
            <option value="credito">Credito</option>
          </select>
          <text-input v-if="form.method && form.method !== 'efectivo'" v-model="form.referencePay" label="Referencia" class="mt-2 w-full" /> -->
          </div>
        </div>
      </div>

      <div v-if="mode == 'pay'" class="mb-4 px-8 py-6 bg-purple-50 rounded-lg shadow-lg">
        <h2 class="mb-4 text-lg font-medium">Datos de pago</h2>
        <div>
          <label for="">Metodo de pago</label>
          <select v-model="form.method" class="form-input mt-2 w-full border-2 border-gray-600 rounded">
            <option value="">Seleccionar</option>
            <option value="efectivo">Efectivo</option>
            <option value="transferencia">Transferencia Bs</option>
            <option value="transferencia-usd">Transferencia Divisas</option>
            <option value="biopago">Zelle</option>
            <option value="credito">Credito</option>
          </select>
          <text-input v-if="form.method && form.method !== 'efectivo'" v-model="form.referencePay" label="Referencia" class="mt-2 w-full" />
          <text-input v-if="form.method && form.method === 'efectivo'" v-model="cambio" label="Dinero que dió" class="mt-2 w-full" />
        </div>
      </div>

      <div v-if="mode == 'print'" class="mb-4 px-8 py-6 bg-orange-50 rounded shadow-lg">
        <h2 class="mb-4 text-lg font-medium">Comprobantes</h2>

        <div class="p-5">
          <button class="btn-blue" type="button"><i class="fa fa-print"></i> Nota de entrega</button>
          <button class="btn-blue" type="button"><i class="fa fa-print"></i> Nota de entrega</button>
          <button class="btn-blue" type="button"><i class="fa fa-print"></i> Térmica</button>
        </div>
      </div>
    </div>
    <div class="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-blue-700 to-blue-900 text-white shadow-2xl border-t-4 border-yellow-400 p-6 z-40">
      <div class="flex items-center justify-between">
        <div class="flex-1">
          <div class="grid grid-cols-1 md:grid-cols-4 gap-4 text-center">
            <div v-if="cambio" class="bg-black bg-opacity-30 rounded-lg p-3 border border-white border-opacity-20">
              <div class="text-sm font-semibold text-yellow-300">Cambio</div>
              <div class="text-2xl text-white font-black">${{ formatCurrency(cambio - getTotal()) }}</div>
            </div>
            <div class="bg-black bg-opacity-30 rounded-lg p-3 border border-white border-opacity-20">
              <div class="text-sm font-semibold text-emerald-300">Total USD ($)</div>
              <div class="text-2xl text-white font-black">${{ formatCurrency(getTotalWithDiscount()) }}</div>
            </div>
            <div class="bg-black bg-opacity-30 rounded-lg p-3 border border-white border-opacity-20">
              <div class="text-sm font-semibold text-blue-200">Total Bs.</div>
              <div class="text-2xl text-white font-black">{{ formatCurrency(getTotalWithDiscount() * change) }}</div>
            </div>
            <div class="bg-black bg-opacity-30 rounded-lg p-3 border border-white border-opacity-20">
              <div class="text-sm font-semibold text-purple-200">Total COP</div>
              <div class="text-2xl text-white font-black">{{ formatCurrency(getTotalCopWithDiscount()) }}</div>
            </div>
          </div>
        </div>
        <div class="flex items-center space-x-3 ml-6">
          <button v-if="mode != 'cart'" @click="back" class="px-6 py-3 text-blue-700 font-extrabold bg-white hover:bg-gray-100 rounded-lg shadow-lg transition-all duration-200 transform hover:scale-105">
            Atrás
          </button>
          <button @click="next" class="px-7 py-3 text-gray-900 font-black text-base bg-yellow-400 hover:bg-yellow-300 rounded-lg shadow-xl transition-all duration-200 transform hover:scale-105 border-2 border-yellow-500">
            Cobrar / Siguiente [F9]
          </button>
        </div>
      </div>
    </div>

    <!-- MODAL DE COBRO POS / SELECCIÓN DE MONEDAS -->
    <div v-if="showPaymentModal" class="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-70 flex justify-center items-start p-2 sm:p-4 md:py-6">
      <div class="bg-white rounded-2xl shadow-2xl max-w-2xl w-full border border-gray-300 overflow-hidden flex flex-col my-auto max-h-[95vh]">
        
        <!-- Header del Modal -->
        <div class="bg-gray-900 text-white px-4 py-3 sm:px-5 sm:py-3.5 flex items-center justify-between border-b border-gray-800">
          <div>
            <h2 class="text-lg sm:text-xl font-bold flex items-center">
              <i class="fa fa-cash-register text-yellow-400 mr-2"></i>
              Cobrar Venta - Selección de Moneda(s)
            </h2>
            <p class="text-[11px] sm:text-xs text-gray-300 mt-0.5">Especifique la moneda o monedas con las que cancela el cliente</p>
          </div>
          <button @click="closePaymentModal" class="text-gray-400 hover:text-white p-1.5 rounded-lg text-lg cursor-pointer">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <!-- Totales de la Orden en las Monedas -->
        <div class="bg-gray-100 p-2 sm:p-3 border-b border-gray-200 grid grid-cols-2 sm:grid-cols-4 gap-2 text-center">
          <div class="bg-white p-1.5 sm:p-2 rounded-lg border-2 border-emerald-400 shadow-sm">
            <span class="text-[10px] sm:text-[11px] font-black text-emerald-800 block uppercase">Dólar Efectivo ($)</span>
            <span class="text-base sm:text-lg font-black text-emerald-700">${{ formatCurrency(totalCashUsd) }}</span>
            <span class="text-[10px] text-gray-500 font-bold block">Tasa: {{ cashDollarRate }} COP/$</span>
          </div>
          <div class="bg-white p-1.5 sm:p-2 rounded-lg border-2 border-blue-300 shadow-sm">
            <span class="text-[10px] sm:text-[11px] font-bold text-gray-500 block uppercase">Total Bolívares</span>
            <span class="text-base sm:text-lg font-black text-blue-700">Bs. {{ formatCurrency(totalBs) }}</span>
          </div>
          <div class="bg-white p-1.5 sm:p-2 rounded-lg border-2 border-purple-300 shadow-sm">
            <span class="text-[10px] sm:text-[11px] font-bold text-gray-500 block uppercase">Total Pesos (COP)</span>
            <span class="text-base sm:text-lg font-black text-purple-700">COP {{ formatCurrency(totalCop) }}</span>
          </div>
          <div class="bg-white p-1.5 sm:p-2 rounded-lg border-2 border-gray-300 shadow-sm">
            <span class="text-[10px] sm:text-[11px] font-bold text-gray-500 block uppercase">Ref. BCV ($)</span>
            <span class="text-base sm:text-lg font-black text-gray-600">${{ formatCurrency(totalUsd) }}</span>
            <span class="text-[10px] text-gray-400 block">Oficial</span>
          </div>
        </div>

        <!-- Tabs de Selección de Moneda -->
        <div class="p-2 sm:p-3 bg-white border-b border-gray-200">
          <label class="block text-[11px] sm:text-xs font-bold text-gray-700 mb-1.5 uppercase tracking-wide">¿Cómo cancela el cliente?</label>
          <div class="grid grid-cols-2 sm:grid-cols-5 gap-1.5 sm:gap-2">
            <button type="button" @click="selectPaymentTab('cash_usd')"
              class="py-2 px-1.5 rounded-lg text-xs sm:text-sm font-bold flex items-center justify-center transition cursor-pointer"
              :style="paymentTab === 'cash_usd' ? 'background-color: #059669; color: #ffffff; border: 1.5px solid #047857; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);' : 'background-color: #f3f4f6; color: #1f2937; border: 1.5px solid #d1d5db;'">
              <i class="fa fa-dollar-sign mr-1"></i> Dólar Efectivo ($)
            </button>
            <button type="button" @click="selectPaymentTab('bs')"
              class="py-2 px-1.5 rounded-lg text-xs sm:text-sm font-bold flex items-center justify-center transition cursor-pointer"
              :style="paymentTab === 'bs' ? 'background-color: #2563eb; color: #ffffff; border: 1.5px solid #1d4ed8; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);' : 'background-color: #f3f4f6; color: #1f2937; border: 1.5px solid #d1d5db;'">
              <i class="fa fa-money-bill-alt mr-1"></i> Bolívares (Bs)
            </button>
            <button type="button" @click="selectPaymentTab('cop')"
              class="py-2 px-1.5 rounded-lg text-xs sm:text-sm font-bold flex items-center justify-center transition cursor-pointer"
              :style="paymentTab === 'cop' ? 'background-color: #7c3aed; color: #ffffff; border: 1.5px solid #6d28d9; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);' : 'background-color: #f3f4f6; color: #1f2937; border: 1.5px solid #d1d5db;'">
              <i class="fa fa-coins mr-1"></i> Pesos (COP)
            </button>
            <button type="button" @click="selectPaymentTab('ref_usd')"
              class="py-2 px-1.5 rounded-lg text-xs sm:text-sm font-bold flex items-center justify-center transition cursor-pointer"
              :style="paymentTab === 'ref_usd' ? 'background-color: #0284c7; color: #ffffff; border: 1.5px solid #0369a1; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);' : 'background-color: #f3f4f6; color: #1f2937; border: 1.5px solid #d1d5db;'">
              <i class="fa fa-university mr-1"></i> Dólar Ref. / Zelle
            </button>
            <button type="button" @click="selectPaymentTab('mixed')"
              class="py-2 px-1.5 rounded-lg text-xs sm:text-sm font-bold flex items-center justify-center transition cursor-pointer"
              :style="paymentTab === 'mixed' ? 'background-color: #d97706; color: #ffffff; border: 1.5px solid #b45309; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);' : 'background-color: #f3f4f6; color: #1f2937; border: 1.5px solid #d1d5db;'">
              <i class="fa fa-balance-scale mr-1"></i> Mixto / Varias
            </button>
          </div>
        </div>

        <!-- Contenido según Tab seleccionado -->
        <div class="p-4 sm:p-5 overflow-y-auto flex-1 space-y-3 sm:space-y-4">
          
          <!-- Banner cuando no hay moneda seleccionada -->
          <div v-if="!paymentTab" class="text-center py-10 px-6 bg-gray-50 rounded-2xl border-2 border-dashed border-gray-300">
            <div class="w-16 h-16 mx-auto mb-3 bg-teal-100 text-teal-700 rounded-full flex items-center justify-center text-2xl shadow-inner">
              <i class="fa fa-hand-pointer"></i>
            </div>
            <h3 class="text-lg font-bold text-gray-800 mb-1">Selecciona la Moneda / Forma de Pago</h3>
            <p class="text-sm text-gray-500 max-w-md mx-auto">
              Haz clic en una de las opciones superiores (<strong>Dólares, Bolívares, Pesos o Mixto</strong>) para elegir el método y monto a recibir.
            </p>
          </div>

          <!-- TAB DÓLAR EFECTIVO ($ BILLETES) -->
          <div v-if="paymentTab === 'cash_usd'" class="space-y-4">
            
            <!-- Banner Tasa de Cambio Peso / Dólar Efectivo -->
            <div class="p-3 bg-emerald-50 border border-emerald-300 rounded-xl flex flex-wrap items-center justify-between text-xs gap-2">
              <div class="flex items-center space-x-2">
                <i class="fa fa-money-bill-wave text-emerald-700 text-lg"></i>
                <div>
                  <span class="font-bold text-emerald-950 uppercase">Tasa Dólar Efectivo (Mercado de Pesos):</span>
                  <span class="text-emerald-800 ml-1">COP {{ formatCurrency(totalCop) }} ÷ {{ cashDollarRate }} = <strong>${{ formatCurrency(totalCashUsd) }} USD</strong></span>
                </div>
              </div>
              <div class="flex items-center space-x-1.5 bg-white px-2.5 py-1 rounded-lg border border-emerald-300 shadow-sm">
                <span class="text-emerald-900 font-bold text-xs">Tasa del día:</span>
                <span class="px-1.5 py-0.5 text-xs font-black text-emerald-900">{{ cashDollarRate }}</span>
                <span class="text-emerald-700 font-bold text-xs">COP/$</span>
              </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-bold text-gray-800 mb-1">Método de Pago</label>
                <div class="w-full border-2 border-emerald-300 bg-emerald-50/50 rounded-lg p-2.5 text-emerald-950 font-extrabold flex items-center justify-between">
                  <span>Efectivo Dólar ($ USD Físico)</span>
                  <i class="fa fa-money-bill-alt text-emerald-600"></i>
                </div>
              </div>

              <div>
                <label class="block text-sm font-bold text-gray-800 mb-1">
                  Monto Recibido en Dólares Físicos ($ USD)
                </label>
                <input type="number" step="0.01" min="0" v-model.number="singlePay.amountGiven"
                  class="w-full border-2 border-emerald-400 rounded-lg p-2.5 text-gray-900 font-black text-xl bg-white focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500" />
                <span class="text-xs text-emerald-800 font-semibold mt-1 block">Equivalente a COP {{ formatCurrency(Math.round((singlePay.amountGiven * cashDollarRate) / 100) * 100) }} (Tasa: {{ cashDollarRate }})</span>
              </div>
            </div>

            <!-- Cambio / Vuelto en Dólar Efectivo -->
            <div v-if="singleCashVueltoUsd > 0"
              class="p-4 sm:p-5 bg-gradient-to-r from-emerald-50 to-teal-50 border-2 border-emerald-400 rounded-xl shadow-sm space-y-3">
              <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                <div>
                  <span class="text-xs font-extrabold text-emerald-800 uppercase tracking-wide block">
                    <i class="fa fa-hand-holding-usd mr-1"></i> Vuelto en Dólar Efectivo:
                  </span>
                  <span class="text-2xl sm:text-3xl font-black text-emerald-900">
                    ${{ formatCurrency(singleCashVueltoUsd) }} <span class="text-sm font-bold">USD</span>
                  </span>
                </div>

                <div class="bg-white p-3 sm:px-4 sm:py-2.5 rounded-xl border border-emerald-300 shadow-sm text-right">
                  <span class="text-xs font-black text-emerald-700 uppercase tracking-wider block">
                    <i class="fa fa-money-bill-wave mr-1 text-emerald-600"></i> VUELTO A ENTREGAR EN PESOS (COP):
                  </span>
                  <span class="text-2xl sm:text-3xl font-black text-emerald-800 tracking-tight">
                    COP {{ formatCurrency(singleCashVueltoCop) }}
                  </span>
                  <div class="text-[11px] font-semibold text-gray-500 mt-0.5">
                    ${{ formatCurrency(singleCashVueltoUsd) }} USD × {{ cashDollarRate }} COP
                  </div>
                </div>
              </div>

              <div class="pt-2 border-t border-emerald-200/60 flex justify-between items-center text-xs text-emerald-800">
                <span>Vuelto en efectivo frontera</span>
                <span v-if="effectiveRateCopBs > 0" class="text-gray-600 font-medium">
                  Equiv. en Bolívares: <strong class="text-gray-800 font-bold">Bs. {{ formatCurrency(singleCashVueltoCop / effectiveRateCopBs) }}</strong>
                </span>
              </div>
            </div>
          </div>

          <!-- TAB DÓLARES REF / ZELLE / DIVISAS (OFICIAL) -->
          <div v-if="paymentTab === 'ref_usd'" class="space-y-4">
            <div class="p-3 bg-sky-50 border border-sky-300 rounded-xl text-xs text-sky-900 flex items-center justify-between">
              <div>
                <span class="font-bold uppercase"><i class="fa fa-info-circle mr-1"></i> Referencia Oficial:</span>
                Total de la venta a tasa referencia: <strong>${{ formatCurrency(totalUsd) }} USD</strong> (Para pagos electrónicos / Zelle / Transferencias).
              </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-bold text-gray-800 mb-1">Método de Pago</label>
                <select v-model="singlePay.method" class="w-full border-2 border-gray-300 rounded-lg p-2.5 text-gray-900 bg-white font-medium focus:ring-2 focus:ring-sky-500 focus:border-sky-500">
                  <option v-for="m in methodsUsd" :key="m.id || m.name" :value="m.name">{{ m.name }}</option>
                </select>
              </div>

              <div>
                <label class="block text-sm font-bold text-gray-800 mb-1">Monto a Cobrar ($ USD)</label>
                <input type="number" step="0.01" min="0" v-model.number="singlePay.amountGiven"
                  class="w-full border-2 border-gray-300 rounded-lg p-2.5 text-gray-900 font-bold text-lg bg-white focus:ring-2 focus:ring-sky-500 focus:border-sky-500" />
              </div>
            </div>

            <div>
              <label class="block text-sm font-bold text-gray-800 mb-1">Número de Referencia / Comprobante Zelle</label>
              <input type="text" v-model="singlePay.reference" placeholder="Ej: 849302"
                class="w-full border-2 border-gray-300 rounded-lg p-2.5 text-gray-900 bg-white focus:ring-2 focus:ring-sky-500 focus:border-sky-500" />
            </div>

            <!-- Vuelto si aplica -->
            <div v-if="singleVueltoUsd > 0"
              class="p-4 bg-sky-50 border-2 border-sky-300 rounded-xl">
              <div class="flex items-center justify-between">
                <div>
                  <span class="text-xs font-bold text-sky-800 uppercase block">Vuelto / Saldo a Favor:</span>
                  <span class="text-2xl font-black text-sky-900">${{ formatCurrency(singleVueltoUsd) }} USD</span>
                </div>
              </div>
            </div>
          </div>

          <!-- TAB BOLÍVARES (Bs) -->
          <div v-if="paymentTab === 'bs'" class="space-y-4">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-bold text-gray-800 mb-1">Método de Pago en Bolívares</label>
                <select v-model="singlePay.method" class="w-full border-2 border-gray-300 rounded-lg p-2.5 text-gray-900 bg-white font-medium focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                  <option :value="null" disabled>-- Seleccione Método de Pago --</option>
                  <option v-for="m in methodsBs" :key="m.id" :value="m.name">{{ m.name }}</option>
                  <option v-if="!methodsBs.length" value="Pago Móvil">Pago Móvil</option>
                  <option v-if="!methodsBs.length" value="Punto de Venta">Punto de Venta</option>
                  <option v-if="!methodsBs.length" value="Efectivo Bs">Efectivo Bs</option>
                  <option v-if="!methodsBs.length" value="Transferencia Bs">Transferencia Bs</option>
                </select>
              </div>

              <div>
                <label class="block text-sm font-bold text-gray-800 mb-1">
                  {{ isCashMethod(singlePay.method) ? 'Monto Recibido (Bs)' : 'Monto a Cobrar (Bs)' }}
                </label>
                <input type="number" step="0.01" min="0" v-model.number="singlePay.amountGiven"
                  class="w-full border-2 border-gray-300 rounded-lg p-2.5 text-gray-900 font-bold text-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                <span class="text-xs text-gray-500 mt-1 block">Equivalente a ${{ formatCurrency(singlePay.amountGiven / (change || 1)) }} USD (Tasa: {{ change }} Bs/$)</span>
              </div>
            </div>

            <!-- Referencia si no es efectivo -->
            <div v-if="singlePay.method && !isCashMethod(singlePay.method)">
              <label class="block text-sm font-bold text-gray-800 mb-1">Número de Referencia / Comprobante</label>
              <input type="text" v-model="singlePay.reference" placeholder="Ej: 4 últimos dígitos o número de comprobante"
                class="w-full border-2 border-gray-300 rounded-lg p-2.5 text-gray-900 bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
            </div>

            <!-- Vuelto en Bs -->
            <div v-if="isCashMethod(singlePay.method) && singleVueltoBs > 0"
              class="p-4 bg-blue-50 border-2 border-blue-300 rounded-xl flex items-center justify-between">
              <div>
                <span class="text-xs font-bold text-blue-800 uppercase block">Vuelto / Cambio en Bolívares:</span>
                <span class="text-2xl font-black text-blue-900">Bs. {{ formatCurrency(singleVueltoBs) }}</span>
              </div>
              <span class="text-xs text-blue-700 font-semibold">(Equiv. ${{ formatCurrency(singleVueltoBs / (change || 1)) }} USD)</span>
            </div>
          </div>

          <!-- TAB PESOS (COP) -->
          <div v-if="paymentTab === 'cop'" class="space-y-4">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-bold text-gray-800 mb-1">Método de Pago en Pesos</label>
                <select v-model="singlePay.method" class="w-full border-2 border-gray-300 rounded-lg p-2.5 text-gray-900 bg-white font-medium focus:ring-2 focus:ring-purple-500 focus:border-purple-500">
                  <option :value="null" disabled>-- Seleccione Método de Pago --</option>
                  <option v-for="m in methodsCop" :key="m.id" :value="m.name">{{ m.name }}</option>
                  <option v-if="!methodsCop.length" value="Efectivo Pesos (COP)">Efectivo Pesos (COP)</option>
                  <option v-if="!methodsCop.length" value="Transferencia COP">Transferencia COP</option>
                </select>
              </div>

              <div>
                <label class="block text-sm font-bold text-gray-800 mb-1">
                  {{ isCashMethod(singlePay.method) ? 'Monto Recibido (COP)' : 'Monto a Cobrar (COP)' }}
                </label>
                <input type="number" step="100" min="0" v-model.number="singlePay.amountGiven"
                  class="w-full border-2 border-gray-300 rounded-lg p-2.5 text-gray-900 font-bold text-lg bg-white focus:ring-2 focus:ring-purple-500 focus:border-purple-500" />
                <span class="text-xs text-gray-500 mt-1 block">Equivalente a ${{ formatCurrency(singlePay.amountGiven / (rateCop || 1)) }} USD</span>
              </div>
            </div>

            <!-- Referencia si no es efectivo -->
            <div v-if="!isCashMethod(singlePay.method)">
              <label class="block text-sm font-bold text-gray-800 mb-1">Número de Referencia / Comprobante COP</label>
              <input type="text" v-model="singlePay.reference" placeholder="Ej: 584902"
                class="w-full border-2 border-gray-300 rounded-lg p-2.5 text-gray-900 bg-white focus:ring-2 focus:ring-purple-500 focus:border-purple-500" />
            </div>

            <!-- Vuelto en COP -->
            <div v-if="isCashMethod(singlePay.method) && singleVueltoCop > 0"
              class="p-4 bg-purple-50 border-2 border-purple-300 rounded-xl flex items-center justify-between">
              <div>
                <span class="text-xs font-bold text-purple-800 uppercase block">Vuelto / Cambio en COP:</span>
                <span class="text-2xl font-black text-purple-900">COP {{ formatCurrency(singleVueltoCop) }}</span>
              </div>
              <span class="text-xs text-purple-700 font-semibold">(Equiv. ${{ formatCurrency(singleVueltoCop / (rateCop || 1)) }} USD)</span>
            </div>
          </div>

          <!-- TAB MIXTO / MULTI-MONEDA -->
          <div v-if="paymentTab === 'mixed'" class="space-y-4">
            
            <!-- Banners Informativos de Tasas de la Venta -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs">
              <!-- Banner Tasa Variante Peso / Bolívar -->
              <div class="p-3 bg-emerald-50 border border-emerald-300 rounded-xl flex items-center justify-between">
                <div>
                  <span class="font-extrabold text-emerald-950 uppercase">
                    <i class="fa fa-calculator text-emerald-700 mr-1"></i> Tasa Variante COP/Bs:
                  </span>
                  <span class="font-black text-sm text-emerald-900 ml-1">{{ Number(effectiveRateCopBs).toFixed(2) }}</span>
                  <span class="block text-[10px] text-emerald-700 mt-0.5">
                    COP {{ formatCurrency(totalCop) }} ÷ Bs. {{ formatCurrency(totalBs) }}
                  </span>
                </div>
                <div class="text-right text-[10px] text-emerald-800 font-medium">
                  <div>COP ÷ {{ Number(effectiveRateCopBs).toFixed(2) }} = Bs</div>
                  <div>Bs × {{ Number(effectiveRateCopBs).toFixed(2) }} = COP</div>
                </div>
              </div>

              <!-- Banner Tasa Dólar Efectivo -->
              <div class="p-3 bg-teal-50 border border-teal-300 rounded-xl flex items-center justify-between">
                <div>
                  <span class="font-extrabold text-teal-950 uppercase">
                    <i class="fa fa-money-bill-wave text-teal-700 mr-1"></i> Tasa Dólar Efectivo:
                  </span>
                  <span class="block text-[10px] text-teal-700 mt-0.5">
                    Total COP {{ formatCurrency(totalCop) }} ÷ {{ cashDollarRate }} = <strong>${{ formatCurrency(totalCashUsd) }} USD</strong>
                  </span>
                </div>
                <div class="flex items-center space-x-1 bg-white px-2.5 py-1 rounded border border-teal-300">
                  <span class="text-teal-900 font-black text-xs">{{ cashDollarRate }}</span>
                  <span class="text-[10px] font-bold text-teal-700">COP/$</span>
                </div>
              </div>
            </div>

            <!-- Fila Dólar Efectivo ($ USD Físico) -->
            <div class="p-4 bg-emerald-50 border border-emerald-200 rounded-xl space-y-2">
              <div class="flex items-center justify-between">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input type="checkbox" v-model="mixedPay.usd_cash.enabled" class="h-4 w-4 text-emerald-600 rounded border-gray-300 focus:ring-emerald-500" />
                  <span class="font-bold text-sm text-emerald-950">Pago en Dólar Efectivo ($ USD Billetes)</span>
                </label>
                <button v-if="mixedRemainingUsd > 0 && mixedRemainingCashUsd > 0" type="button" @click="fillRemainingCashUsd"
                  class="text-xs font-bold px-2.5 py-1 rounded shadow-sm cursor-pointer"
                  style="background-color: #059669; color: #ffffff;">
                  Cobrar restante en Dólar Efectivo (${{ formatCurrency(mixedRemainingCashUsd) }})
                </button>
              </div>

              <div v-if="mixedPay.usd_cash.enabled" class="grid grid-cols-1 sm:grid-cols-3 gap-2 pt-1">
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Monto ($ USD Efectivo)</label>
                  <input type="number" step="0.5" min="0" v-model.number="mixedPay.usd_cash.amount"
                    class="w-full border border-gray-300 rounded p-2 text-sm font-bold bg-white" placeholder="0.00" />
                  <span class="text-[10px] text-emerald-800 font-semibold">Equiv. COP {{ formatCurrency(Math.round((mixedPay.usd_cash.amount * cashDollarRate) / 100) * 100) }} (Tasa: {{ cashDollarRate }})</span>
                </div>
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Método</label>
                  <input type="text" readonly value="Efectivo Dolar"
                    class="w-full border border-gray-300 rounded p-2 text-sm bg-gray-100 font-medium text-gray-700" />
                </div>
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Observación / Billete (Opcional)</label>
                  <input type="text" v-model="mixedPay.usd_cash.reference" placeholder="Ej: Billete $20"
                    class="w-full border border-gray-300 rounded p-2 text-sm bg-white" />
                </div>
              </div>
            </div>

            <!-- Fila Dólares Ref. / Zelle ($ USD Oficial) -->
            <div class="p-3 sm:p-3.5 bg-sky-50 border border-sky-200 rounded-xl space-y-2">
              <div class="flex items-center justify-between gap-2">
                <label class="flex items-center space-x-2 cursor-pointer min-w-0">
                  <input type="checkbox" v-model="mixedPay.usd.enabled" class="h-4 w-4 text-sky-600 rounded border-gray-300 focus:ring-sky-500 flex-shrink-0" />
                  <span class="font-bold text-sm text-sky-950 flex items-center">
                    <i class="fa fa-globe text-sky-700 mr-1.5"></i>
                    Dólares Ref.
                    <span class="text-[11px] text-sky-600 font-normal ml-1.5 opacity-80">(Zelle / Transf.)</span>
                  </span>
                </label>
                <button v-if="mixedRemainingUsd > 0" type="button" @click="fillRemainingUsd"
                  class="text-xs font-semibold px-2.5 py-1 rounded shadow-sm cursor-pointer whitespace-nowrap flex-shrink-0"
                  style="background-color: #0284c7; color: #ffffff;">
                  Restante: ${{ formatCurrency(mixedRemainingUsd) }}
                </button>
              </div>

              <div v-if="mixedPay.usd.enabled" class="grid grid-cols-1 sm:grid-cols-3 gap-2 pt-1">
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Monto ($ USD)</label>
                  <input type="number" step="0.01" min="0" v-model.number="mixedPay.usd.amount"
                    class="w-full border border-gray-300 rounded p-2 text-sm font-bold bg-white" placeholder="0.00" />
                </div>
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Método</label>
                  <select v-model="mixedPay.usd.method" class="w-full border border-gray-300 rounded p-2 text-sm bg-white font-medium">
                    <option v-for="m in methodsUsd" :key="m.id || m.name" :value="m.name">{{ m.name }}</option>
                  </select>
                </div>
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Referencia (Opcional)</label>
                  <input type="text" v-model="mixedPay.usd.reference" placeholder="Ref."
                    class="w-full border border-gray-300 rounded p-2 text-sm bg-white" />
                </div>
              </div>
            </div>

            <!-- Fila Bolívares (Bs) -->
            <div class="p-3 sm:p-3.5 bg-blue-50 border border-blue-200 rounded-xl space-y-2">
              <div class="flex items-center justify-between gap-2">
                <label class="flex items-center space-x-2 cursor-pointer min-w-0">
                  <input type="checkbox" v-model="mixedPay.bs.enabled" class="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500 flex-shrink-0" />
                  <span class="font-bold text-sm text-blue-950 flex items-center">
                    <i class="fa fa-money-bill-wave text-blue-700 mr-1.5"></i>
                    Bolívares (Bs)
                  </span>
                </label>
                <button v-if="mixedRemainingUsd > 0" type="button" @click="fillRemainingBs"
                  class="text-xs font-semibold px-2.5 py-1 rounded shadow-sm cursor-pointer whitespace-nowrap flex-shrink-0"
                  style="background-color: #2563eb; color: #ffffff;">
                  Restante: Bs {{ formatCurrency(mixedRemainingBs) }}
                </button>
              </div>

              <div v-if="mixedPay.bs.enabled" class="grid grid-cols-1 sm:grid-cols-3 gap-2 pt-1">
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Monto (Bs)</label>
                  <input type="number" step="0.01" min="0" v-model.number="mixedPay.bs.amount"
                    class="w-full border border-gray-300 rounded p-2 text-sm font-bold bg-white" placeholder="0.00" />
                  <span class="text-[10px] text-gray-500">Equiv. ${{ formatCurrency(mixedPay.bs.amount / (change || 1)) }}</span>
                </div>
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Método</label>
                  <select v-model="mixedPay.bs.method" class="w-full border border-gray-300 rounded p-2 text-sm bg-white font-medium">
                    <option value="Pago Móvil">Pago Móvil</option>
                    <option value="Punto de Venta">Punto de Venta</option>
                    <option value="Efectivo Bs">Efectivo Bs</option>
                    <option value="Transferencia Bs">Transferencia Bs</option>
                    <option v-for="m in methodsBs" :key="m.id" :value="m.name">{{ m.name }}</option>
                  </select>
                </div>
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Referencia</label>
                  <input type="text" v-model="mixedPay.bs.reference" placeholder="Ref."
                    class="w-full border border-gray-300 rounded p-2 text-sm bg-white" />
                </div>
              </div>
            </div>

            <!-- Fila Pesos Efectivo (COP) -->
            <div class="p-3 sm:p-3.5 bg-purple-50 border border-purple-200 rounded-xl space-y-2">
              <div class="flex items-center justify-between gap-2">
                <label class="flex items-center space-x-2 cursor-pointer min-w-0">
                  <input type="checkbox" v-model="mixedPay.cop.enabled" class="h-4 w-4 text-purple-600 rounded border-gray-300 focus:ring-purple-500 flex-shrink-0" />
                  <span class="font-bold text-sm text-purple-950 flex items-center">
                    <i class="fa fa-coins text-purple-700 mr-1.5"></i>
                    Efectivo Pesos (COP)
                  </span>
                </label>
                <button v-if="mixedRemainingUsd > 0" type="button" @click="fillRemainingCop"
                  class="text-xs font-semibold px-2.5 py-1 rounded shadow-sm cursor-pointer whitespace-nowrap flex-shrink-0"
                  style="background-color: #7c3aed; color: #ffffff;">
                  Restante: COP {{ formatCurrency(mixedRemainingCop) }}
                </button>
              </div>

              <div v-if="mixedPay.cop.enabled" class="grid grid-cols-1 sm:grid-cols-3 gap-2 pt-1">
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Monto Efectivo (COP)</label>
                  <input type="number" step="100" min="0" v-model.number="mixedPay.cop.amount"
                    class="w-full border border-gray-300 rounded p-2 text-sm font-bold bg-white" placeholder="0" />
                  <span class="text-[10px] text-gray-500">Equiv. ${{ formatCurrency(mixedPay.cop.amount / (rateCop || 1)) }}</span>
                </div>
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Método</label>
                  <select v-model="mixedPay.cop.method" class="w-full border border-gray-300 rounded p-2 text-sm bg-white font-medium">
                    <option value="Efectivo Pesos (COP)">Efectivo Pesos (COP)</option>
                    <option v-for="m in methodsCop" :key="m.id" :value="m.name">{{ m.name }}</option>
                  </select>
                </div>
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Referencia / Detalle (Opcional)</label>
                  <input type="text" v-model="mixedPay.cop.reference" placeholder="Ej: Billete 50mil"
                    class="w-full border border-gray-300 rounded p-2 text-sm bg-white" />
                </div>
              </div>
            </div>

            <!-- Fila Pesos Transferencia (Bancolombia / Nequi / Daviplata) -->
            <div class="p-3 sm:p-3.5 bg-indigo-50 border border-indigo-200 rounded-xl space-y-2">
              <div class="flex items-center justify-between gap-2">
                <label class="flex items-center space-x-2 cursor-pointer min-w-0">
                  <input type="checkbox" v-model="mixedPay.cop_transfer.enabled" class="h-4 w-4 text-indigo-600 rounded border-gray-300 focus:ring-indigo-500 flex-shrink-0" />
                  <span class="font-bold text-sm text-indigo-950 flex items-center flex-wrap">
                    <i class="fa fa-university text-indigo-700 mr-1.5"></i>
                    Transferencia Pesos (COP)
                    <span class="text-[11px] text-indigo-600 font-normal ml-1.5 opacity-80">(Bancolombia / Nequi)</span>
                  </span>
                </label>
                <button v-if="mixedRemainingUsd > 0" type="button" @click="fillRemainingCopTransfer"
                  class="text-xs font-semibold px-2.5 py-1 rounded shadow-sm cursor-pointer whitespace-nowrap flex-shrink-0"
                  style="background-color: #4f46e5; color: #ffffff;">
                  Restante: COP {{ formatCurrency(mixedRemainingCop) }}
                </button>
              </div>

              <div v-if="mixedPay.cop_transfer.enabled" class="grid grid-cols-1 sm:grid-cols-3 gap-2 pt-1">
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Monto Transferencia (COP)</label>
                  <input type="number" step="100" min="0" v-model.number="mixedPay.cop_transfer.amount"
                    class="w-full border border-gray-300 rounded p-2 text-sm font-bold bg-white" placeholder="0" />
                  <span class="text-[10px] text-gray-500">Equiv. ${{ formatCurrency(mixedPay.cop_transfer.amount / (rateCop || 1)) }}</span>
                </div>
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Método / Banco</label>
                  <select v-model="mixedPay.cop_transfer.method" class="w-full border border-gray-300 rounded p-2 text-sm bg-white font-medium">
                    <option value="Transferencia COP">Transferencia COP</option>
                    <option value="Bancolombia">Bancolombia</option>
                    <option value="Nequi">Nequi</option>
                    <option value="Daviplata">Daviplata</option>
                    <option v-for="m in methodsCop" :key="m.id" :value="m.name">{{ m.name }}</option>
                  </select>
                </div>
                <div>
                  <label class="block text-xs font-semibold text-gray-700">Comprobante / Referencia Bancaria</label>
                  <input type="text" v-model="mixedPay.cop_transfer.reference" placeholder="Ej: 123456 o comprobante"
                    class="w-full border border-gray-300 rounded p-2 text-sm bg-white" />
                </div>
              </div>
            </div>

            <!-- Resumen de Liquidación Mixta -->
            <div class="p-4 sm:p-5 rounded-xl border-2 shadow-sm flex items-center justify-between"
              :class="Math.abs(mixedRemainingCop) <= 50 ? 'bg-green-50 border-green-400 text-green-900' : (mixedRemainingCop > 50 ? 'bg-amber-50 border-amber-400 text-amber-900' : 'bg-blue-50 border-blue-400 text-blue-900')">
              <div>
                <span class="text-xs sm:text-sm font-bold uppercase tracking-wider block opacity-90">Total Pagado:</span>
                <span class="text-xl sm:text-2xl font-black text-gray-900">
                  COP {{ formatCurrency(mixedTotalCopPaid) }}
                </span>
                <span class="text-xs sm:text-sm font-semibold text-gray-600 block">
                  (Equiv. ${{ formatCurrency(mixedTotalCashUsdPaid) }} USD)
                </span>
              </div>
              <div class="text-right">
                <template v-if="Math.abs(mixedRemainingCop) <= 50">
                  <span class="inline-flex items-center text-base sm:text-lg font-black text-green-700 bg-green-200 px-4 py-1.5 rounded-full shadow-sm">
                    <i class="fa fa-check-circle mr-1.5"></i> 100% Cubierto
                  </span>
                </template>
                <template v-else-if="mixedRemainingCop > 50">
                  <span class="text-xs sm:text-sm font-bold uppercase tracking-wider block text-amber-800 opacity-90">Resta por pagar:</span>
                  <span class="text-xl sm:text-2xl font-black text-amber-900">COP {{ formatCurrency(mixedRemainingCop) }}</span>
                  <span class="text-xs sm:text-sm font-semibold text-amber-700 block">
                    (Equiv. ${{ formatCurrency(mixedRemainingCashUsd) }} USD / Bs. {{ formatCurrency(mixedRemainingBs) }})
                  </span>
                </template>
                <template v-else>
                  <span class="text-xs sm:text-sm font-bold uppercase tracking-wider block text-blue-800 opacity-90">Vuelto al cliente:</span>
                  <span class="text-xl sm:text-2xl font-black text-blue-900">COP {{ formatCurrency(Math.abs(mixedRemainingCop)) }}</span>
                  <span class="text-xs sm:text-sm font-semibold text-blue-700 block">
                    (Equiv. ${{ formatCurrency(mixedVueltoCashUsd) }} USD)
                  </span>
                </template>
              </div>
            </div>
          </div>

          <!-- SECCIÓN UNIVERSAL DE VUELTO MULTI-MONEDA Y DESGLOSE FÍSICO DE CAJA -->
          <div v-if="hasActiveVuelto" class="p-4 sm:p-5 bg-gradient-to-r from-blue-50 via-sky-50 to-indigo-50 border-2 border-blue-400 rounded-2xl shadow-md space-y-3">
            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 border-b border-blue-200 pb-3">
              <div>
                <span class="text-xs font-black text-blue-900 uppercase tracking-wider flex items-center">
                  <i class="fa fa-hand-holding-usd text-blue-600 mr-2 text-base"></i>
                  Vuelto a Entregar al Cliente
                </span>
                <div class="flex flex-wrap items-baseline gap-2 sm:gap-3 mt-1">
                  <span class="text-2xl font-black text-blue-950">COP {{ formatCurrency(activeTotalVueltoCop) }}</span>
                  <span class="text-base font-bold text-emerald-800">| ${{ formatCurrency(activeTotalVueltoUsd) }} USD</span>
                  <span class="text-xs font-semibold text-gray-700">| Bs. {{ formatCurrency(activeTotalVueltoBs) }}</span>
                </div>
              </div>

              <!-- Botones de Acción Rápida para Definir Moneda del Vuelto -->
              <div class="flex flex-wrap gap-1.5 items-center">
                <span class="text-[11px] font-bold text-blue-900 block w-full sm:w-auto mr-1">Entregar todo en:</span>
                <button type="button" @click="setChangeAll('cop')"
                  class="text-xs font-bold px-3 py-1.5 rounded-lg bg-purple-700 hover:bg-purple-800 text-white transition shadow-sm cursor-pointer">
                  Todo en COP
                </button>
                <button type="button" @click="setChangeAll('usd')"
                  class="text-xs font-bold px-3 py-1.5 rounded-lg bg-emerald-700 hover:bg-emerald-800 text-white transition shadow-sm cursor-pointer">
                  Todo en USD ($)
                </button>
                <button type="button" @click="setChangeAll('bs')"
                  class="text-xs font-bold px-3 py-1.5 rounded-lg bg-sky-700 hover:bg-sky-800 text-white transition shadow-sm cursor-pointer">
                  Todo en Bs
                </button>
              </div>
            </div>

            <!-- Desglose de Entrega Física de Caja -->
            <div class="space-y-2">
              <label class="block text-xs font-extrabold text-blue-950 uppercase tracking-wide">
                <i class="fa fa-cash-register text-blue-700 mr-1"></i>
                Moneda entregada físicamente (se descontará exactamente de la caja):
              </label>
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-2.5">
                <!-- Vuelto COP -->
                <div class="bg-white p-2.5 rounded-xl border-2 border-purple-300 shadow-sm">
                  <span class="text-xs font-bold text-purple-900 block mb-1">Pesos Efectivo (COP)</span>
                  <div class="relative">
                    <input type="number" step="100" min="0" v-model.number="changeGiven.cop" @input="changeGiven.customized = true"
                      class="w-full font-black text-lg text-purple-950 p-1.5 border border-purple-200 rounded-lg bg-purple-50/50 focus:bg-white focus:ring-2 focus:ring-purple-500" placeholder="0" />
                  </div>
                </div>

                <!-- Vuelto USD -->
                <div class="bg-white p-2.5 rounded-xl border-2 border-emerald-300 shadow-sm">
                  <span class="text-xs font-bold text-emerald-900 block mb-1">Dólares Efectivo ($ CASH)</span>
                  <div class="relative">
                    <input type="number" step="0.5" min="0" v-model.number="changeGiven.usd" @input="changeGiven.customized = true"
                      class="w-full font-black text-lg text-emerald-950 p-1.5 border border-emerald-200 rounded-lg bg-emerald-50/50 focus:bg-white focus:ring-2 focus:ring-emerald-500" placeholder="0.00" />
                  </div>
                </div>

                <!-- Vuelto Bs -->
                <div class="bg-white p-2.5 rounded-xl border-2 border-sky-300 shadow-sm">
                  <span class="text-xs font-bold text-sky-900 block mb-1">Bolívares Efectivo (Bs)</span>
                  <div class="relative">
                    <input type="number" step="0.1" min="0" v-model.number="changeGiven.bs" @input="changeGiven.customized = true"
                      class="w-full font-black text-lg text-sky-900 p-1.5 border border-sky-200 rounded-lg bg-sky-50/50 focus:bg-white focus:ring-2 focus:ring-sky-500" placeholder="0.00" />
                  </div>
                </div>
              </div>

              <!-- Indicador de balance del vuelto entregado -->
              <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between text-xs pt-1 gap-1">
                <span class="text-gray-700 font-medium">
                  Total entregado en físico: <strong class="text-gray-900 font-bold">COP {{ formatCurrency(deliveredChangeCop) }}</strong>
                </span>
                <div>
                  <span v-if="Math.abs(deliveredChangeCop - activeTotalVueltoCop) <= 100" class="text-emerald-700 font-black inline-flex items-center">
                    <i class="fa fa-check-circle mr-1"></i> Vuelto exacto cubierto
                  </span>
                  <span v-else-if="deliveredChangeCop < activeTotalVueltoCop" class="text-amber-800 font-bold inline-flex items-center">
                    Faltan COP {{ formatCurrency(activeTotalVueltoCop - deliveredChangeCop) }}
                    <button type="button" @click="completeRemainingChangeCop"
                      class="ml-2 px-2 py-0.5 bg-amber-600 text-white rounded font-bold hover:bg-amber-700 text-[11px] shadow-sm cursor-pointer">
                      + Completar en COP
                    </button>
                  </span>
                  <span v-else class="text-rose-700 font-bold inline-flex items-center">
                    <i class="fa fa-exclamation-triangle mr-1"></i> Excedido por COP {{ formatCurrency(deliveredChangeCop - activeTotalVueltoCop) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer / Botones de Acción -->
        <div class="bg-gray-100 px-4 py-3 sm:px-5 sm:py-3.5 border-t border-gray-300 flex items-center justify-between">
          <button type="button" @click="closePaymentModal"
            class="px-4 py-2.5 sm:px-5 sm:py-3 rounded-xl border border-gray-400 bg-white hover:bg-gray-200 text-gray-800 font-bold transition shadow-sm text-sm">
            Cancelar
          </button>
          <button type="button" @click="processPaymentAndSubmit"
            :disabled="!paymentTab || (paymentTab !== 'mixed' && !singlePay.method)"
            class="px-5 py-2.5 sm:px-8 sm:py-3.5 rounded-xl font-extrabold text-sm sm:text-base transition shadow-lg flex items-center space-x-2"
            :class="(!paymentTab || (paymentTab !== 'mixed' && !singlePay.method)) ? 'bg-gray-400 text-gray-200 cursor-not-allowed opacity-60' : 'bg-emerald-600 hover:bg-emerald-700 text-white cursor-pointer shadow-emerald-200'">
            <i class="fa fa-check text-lg"></i>
            <span>Confirmar y Finalizar Venta [F9]</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Retiro de Efectivo de Caja -->
    <withdrawal-modal
      :show="showWithdrawalModal"
      @close="showWithdrawalModal = false"
      :is-admin="$page.props.auth?.user?.role === 'admin'"
    />

    <!-- Modal de Avance de Efectivo en Pesos (COP) -->
    <cash-advance-modal
      :show="showCashAdvanceModal"
      :default-rate="(cop_bs_rate > 0 ? cop_bs_rate : (cop_change > 0 ? cop_change : ($page.props.cop_bs_rate > 0 ? $page.props.cop_bs_rate : ($page.props.cop_change > 0 ? $page.props.cop_change : effectiveRateCopBs))))"
      @close="showCashAdvanceModal = false"
    />

    <!-- Modal de Apertura Obligatoria de Caja -->
    <open-cash-register-modal
      :show="!user_cash_register"
      :user-name="$page.props.auth?.user?.first_name || 'Usuario'"
      @opened="handleRegisterOpened"
    />

    <!-- Modal de Arqueo y Cierre de Caja -->
    <cash-audit-modal
      :show="showAuditModal"
      :cash-register-id="user_cash_register?.id"
      :register-name="user_cash_register?.name || ''"
      :cashier-name="user_cash_register?.opened_by_name || $page.props.auth?.user?.first_name || ''"
      :is-admin="$page.props.auth?.user?.role === 'admin'"
      @close="showAuditModal = false"
    />
  </div>
</template>

<script>
import LayoutFull from '../../Shared/LayoutFull.vue'
import ProductCard from '../../Shared/ProductCard.vue'
import TextInput from '../../Shared/TextInput.vue'
import TextInputRounded from '../../Shared/TextInputRounded.vue'
import pickBy from 'lodash/pickBy'
import SelectInput from '../../Shared/SelectInput.vue'
import debounce from 'lodash/debounce'
import WithdrawalModal from '../../Shared/WithdrawalModal.vue'
import CashAdvanceModal from '../../Shared/CashAdvanceModal.vue'
import OpenCashRegisterModal from '../../Shared/OpenCashRegisterModal.vue'
import CashAuditModal from '../../Shared/CashAuditModal.vue'

export default {
  components: {
    ProductCard,
    TextInput,
    TextInputRounded,
    SelectInput,
    WithdrawalModal,
    CashAdvanceModal,
    OpenCashRegisterModal,
    CashAuditModal
  },
  layout: LayoutFull,
  props: {
    products: Object,
    change: Number,
    cop_change: Number,
    cop_bs_rate: Number,
    client: Object,
    product_categories: Object,
    surcharge_percent_default: Number,
    payment_methods: Array,
    user_cash_register: Object,
    is_admin: Boolean,
    filters: Object,
    user_deposit_id: [Number, String, null],
  },
  data() {
    return {
      cambio: 0,
      showClientCreate: false,
      showWithdrawalModal: false,
      showCashAdvanceModal: false,
      showAuditModal: false,
      mode: 'cart',
      selectedDiscount: '0',
      selectedSurcharge: this.surcharge_percent_default ? Math.floor(this.surcharge_percent_default).toString() : '0',
      customSurcharge: 0,
      showPaymentModal: false,
      paymentTab: 'cash_usd',
      cashDollarRate: (this.cop_change > 0 ? this.cop_change : 3200),
      singlePay: {
        method: 'Efectivo Dolar',
        amountGiven: 0,
        reference: '',
      },
      mixedPay: {
        usd_cash: { enabled: true, amount: 0, method: 'Efectivo Dolar', reference: '' },
        usd: { enabled: false, amount: 0, method: 'Zelle', reference: '' },
        bs: { enabled: false, amount: 0, method: 'Pago Móvil', reference: '' },
        cop: { enabled: false, amount: 0, method: 'Efectivo Pesos (COP)', reference: '' },
        cop_transfer: { enabled: false, amount: 0, method: 'Transferencia COP', reference: '' },
      },
      changeGiven: {
        usd: 0,
        cop: 0,
        bs: 0,
        customized: false,
      },
      form: this.$inertia.form({
        search: {
          terms: (this.filters && this.filters.terms) || '',
          category: (this.filters && this.filters.category) || '',
          only_stock: this.filters && this.filters.only_stock !== undefined
            ? (this.filters.only_stock === 'true' || this.filters.only_stock === true)
            : true,
        },
        client: {
          identification: '',
        },
        products: null,
        isCredit: false,
        comentary: 'Compra rapida!',
        referencePay: '',
        quick: true,
        discount: null,
        surcharge: null,
        payments: [],
        change_given: null,
        cash_register_id: this.user_cash_register ? this.user_cash_register.id : null,
      }),
      cart: [],
      withoutClient: true,
      check: false,
      debouncedSearch: null
    }
  },
  watch: {
    activeTotalVueltoCop(newVal) {
      if (!this.changeGiven.customized) {
        if (newVal >= 50) {
          this.changeGiven.cop = newVal
          this.changeGiven.usd = 0
          this.changeGiven.bs = 0
        } else {
          this.changeGiven.cop = 0
          this.changeGiven.usd = 0
          this.changeGiven.bs = 0
        }
      }
    },
    cop_change(newVal) {
      if (newVal > 0) {
        this.cashDollarRate = newVal
      }
    },
    'form.search.terms': function () {
      this.debouncedSearch()
    },
    'form.search.category': function () {
      this.debouncedSearch()
    },
    'form.search.only_stock': function () {
      this.debouncedSearch()
    },
    products: {
      handler(val) {
        if (this.products.data.length === 1) {
          const product = this.products.data[0]
          if (product.code === this.form.search.terms) {
            if (product.quantity <= 0) {
              this.form.search.terms = ''
              return alert('No hay stock de este producto')
            }
            // Solo agrega si no está en el carrito
            const exists = this.cart.find((prd) => prd.id === product.id)
            if (!exists) {
              this.cart.push({ ...product, stock: product.quantity, quantity: 1, price: product.prices[0]['price'], price_cop: product.price_cop, quick: false })
            } else {
              exists.quantity += 1
            }
            this.form.search.terms = ''
          }
        }
      },
      deep: true
    },
  },
  created() {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('pos_cash_dollar_rate')
    }
    // Inicializa la función debounced una sola vez
    this.debouncedSearch = debounce(this.onSearchProductsChange, 400)
    if(!this.isSurchargeVisible)
    {
      this.selectedSurcharge = '0'; 
    }
  },
  computed: {
    isSurchargeVisible() {
      const now = new Date();
      const caracasOffset = -4; // UTC-4
      const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
      const caracas = new Date(utc + (caracasOffset * 3600000));
      const hour = caracas.getHours();
      return hour >= 20 && hour < 22; // 8pm to 9:59pm Caracas (approximately 8pm to 10pm)
    },
    totalUsd() {
      return parseFloat(this.getTotalWithDiscount() || 0)
    },
    totalBs() {
      return parseFloat((this.totalUsd * (this.change || 0)).toFixed(2))
    },
    totalCop() {
      return parseFloat(this.getTotalCopWithDiscount() || 0)
    },
    rateCop() {
      if (this.totalUsd > 0 && this.totalCop > 0) {
        return this.totalCop / this.totalUsd
      }
      return this.cop_change > 0 ? this.cop_change : 4000
    },
    methodsUsd() {
      if (!this.payment_methods || !Array.isArray(this.payment_methods)) return []
      const filtered = this.payment_methods.filter(m => {
        const name = (m.name || '').toLowerCase()
        if (name.includes('efectivo') || name.includes('cash')) return false
        return m.currency_id === 2 || (m.currency && m.currency.alias === 'USD') || name.includes('zelle') || name.includes('binance') || name.includes('transferencia')
      })
      const seen = new Set()
      const result = []
      for (const m of filtered) {
        if (!seen.has(m.name)) {
          seen.add(m.name)
          result.push(m)
        }
      }
      if (!seen.has('Zelle')) result.unshift({ id: 'zelle_fb', name: 'Zelle' })
      if (!seen.has('Transferencia Divisas')) result.push({ id: 'transf_fb', name: 'Transferencia Divisas' })
      return result
    },
    methodsBs() {
      if (!this.payment_methods || !Array.isArray(this.payment_methods)) return []
      const filtered = this.payment_methods.filter(m => {
        const name = (m.name || '').toLowerCase()
        return m.currency_id === 1 || (m.currency && (m.currency.alias === 'VED' || m.currency.alias === 'BS')) || name.includes('bs') || name.includes('móvil') || name.includes('movil') || name.includes('punto')
      })
      return filtered.slice().sort((a, b) => {
        const aIsPunto = (a.name || '').toLowerCase().includes('punto') ? 1 : 0
        const bIsPunto = (b.name || '').toLowerCase().includes('punto') ? 1 : 0
        return bIsPunto - aIsPunto
      })
    },
    methodsCop() {
      if (!this.payment_methods || !Array.isArray(this.payment_methods)) return []
      return this.payment_methods.filter(m => {
        const name = (m.name || '').toLowerCase()
        return m.currency_id === 3 || (m.currency && m.currency.alias === 'COP') || name.includes('cop') || name.includes('peso')
      })
    },
    totalCashUsd() {
      const rate = parseFloat(this.cashDollarRate) || (this.cop_change > 0 ? this.cop_change : 3200)
      return rate > 0 ? parseFloat((this.totalCop / rate).toFixed(2)) : 0
    },
    mixedRemainingCashUsd() {
      const rate = parseFloat(this.cashDollarRate) || (this.cop_change > 0 ? this.cop_change : 3200)
      return rate > 0 ? parseFloat((this.mixedRemainingCop / rate).toFixed(2)) : 0
    },
    singleCashVueltoUsd() {
      if (this.paymentTab !== 'cash_usd') return 0
      const given = parseFloat(this.singlePay.amountGiven) || 0
      return Math.max(0, parseFloat((given - this.totalCashUsd).toFixed(2)))
    },
    singleCashVueltoCop() {
      if (this.singleCashVueltoUsd > 0 && this.cashDollarRate > 0) {
        return Math.round((this.singleCashVueltoUsd * this.cashDollarRate) / 100) * 100
      }
      return 0
    },
    singleVueltoUsd() {
      if (this.paymentTab !== 'ref_usd' && this.paymentTab !== 'usd') return 0
      const given = parseFloat(this.singlePay.amountGiven) || 0
      return Math.max(0, parseFloat((given - this.totalUsd).toFixed(2)))
    },
    singleVueltoBs() {
      if (this.paymentTab !== 'bs') return 0
      const given = parseFloat(this.singlePay.amountGiven) || 0
      return Math.max(0, parseFloat((given - this.totalBs).toFixed(2)))
    },
    singleVueltoCop() {
      if (this.paymentTab !== 'cop') return 0
      const given = parseFloat(this.singlePay.amountGiven) || 0
      return Math.max(0, Math.round(given - this.totalCop))
    },
    effectiveRateCopBs() {
      const totalBsVal = parseFloat(this.totalBs) || 0
      const totalCopVal = parseFloat(this.totalCop) || 0
      if (totalBsVal > 0 && totalCopVal > 0) {
        return parseFloat((totalCopVal / totalBsVal).toFixed(4))
      }
      if (this.change > 0 && this.rateCop > 0) {
        return parseFloat((this.rateCop / this.change).toFixed(4))
      }
      return 1
    },
    mixedTotalCopPaid() {
      const rateCashUsd = parseFloat(this.cashDollarRate) || (this.cop_change > 0 ? this.cop_change : 3200)
      const usdCashVal = this.mixedPay.usd_cash && this.mixedPay.usd_cash.enabled ? (parseFloat(this.mixedPay.usd_cash.amount) || 0) : 0
      const usdRefVal = this.mixedPay.usd && this.mixedPay.usd.enabled ? (parseFloat(this.mixedPay.usd.amount) || 0) : 0
      const bsVal = this.mixedPay.bs && this.mixedPay.bs.enabled ? (parseFloat(this.mixedPay.bs.amount) || 0) : 0
      const copCashVal = this.mixedPay.cop && this.mixedPay.cop.enabled ? (parseFloat(this.mixedPay.cop.amount) || 0) : 0
      const copTransVal = this.mixedPay.cop_transfer && this.mixedPay.cop_transfer.enabled ? (parseFloat(this.mixedPay.cop_transfer.amount) || 0) : 0

      const usdCashInCop = usdCashVal * rateCashUsd
      const usdRefInCop = usdRefVal * (parseFloat(this.rateCop) || rateCashUsd)
      const bsInCop = bsVal * (parseFloat(this.effectiveRateCopBs) || 0)
      const copTotal = copCashVal + copTransVal

      return Math.round(usdCashInCop + usdRefInCop + bsInCop + copTotal)
    },
    mixedTotalCashUsdPaid() {
      const rateCashUsd = parseFloat(this.cashDollarRate) || (this.cop_change > 0 ? this.cop_change : 3200)
      return rateCashUsd > 0 ? parseFloat((this.mixedTotalCopPaid / rateCashUsd).toFixed(2)) : 0
    },
    mixedRemainingCop() {
      return Math.round(this.totalCop - this.mixedTotalCopPaid)
    },
    mixedRemainingCashUsd() {
      const rate = parseFloat(this.cashDollarRate) || (this.cop_change > 0 ? this.cop_change : 3200)
      return rate > 0 ? parseFloat((this.mixedRemainingCop / rate).toFixed(2)) : 0
    },
    mixedVueltoCashUsd() {
      const rate = parseFloat(this.cashDollarRate) || (this.cop_change > 0 ? this.cop_change : 3200)
      return (rate > 0 && this.mixedRemainingCop < -50) ? parseFloat((Math.abs(this.mixedRemainingCop) / rate).toFixed(2)) : 0
    },
    mixedTotalUsdPaid() {
      return this.mixedTotalCashUsdPaid
    },
    mixedRemainingUsd() {
      return this.mixedRemainingCashUsd
    },
    mixedRemainingBs() {
      if (this.mixedRemainingCop <= 0) return 0
      return this.effectiveRateCopBs > 0 ? parseFloat((this.mixedRemainingCop / this.effectiveRateCopBs).toFixed(2)) : 0
    },
    activeTotalVueltoCop() {
      if (this.paymentTab === 'cash_usd') {
        return this.singleCashVueltoCop
      } else if (this.paymentTab === 'cop') {
        return this.singleVueltoCop
      } else if (this.paymentTab === 'bs') {
        return Math.round(this.singleVueltoBs * this.effectiveRateCopBs)
      } else if (this.paymentTab === 'ref_usd' || this.paymentTab === 'usd') {
        const rate = parseFloat(this.cashDollarRate) || (this.cop_change > 0 ? this.cop_change : 3200)
        return Math.round(this.singleVueltoUsd * rate)
      } else if (this.paymentTab === 'mixed') {
        return this.mixedRemainingCop < -50 ? Math.abs(this.mixedRemainingCop) : 0
      }
      return 0
    },
    activeTotalVueltoUsd() {
      const rate = parseFloat(this.cashDollarRate) || (this.cop_change > 0 ? this.cop_change : 3200)
      return rate > 0 ? parseFloat((this.activeTotalVueltoCop / rate).toFixed(2)) : 0
    },
    activeTotalVueltoBs() {
      return this.effectiveRateCopBs > 0 ? parseFloat((this.activeTotalVueltoCop / this.effectiveRateCopBs).toFixed(2)) : 0
    },
    hasActiveVuelto() {
      return this.activeTotalVueltoCop >= 50
    },
    deliveredChangeCop() {
      const rateCashUsd = parseFloat(this.cashDollarRate) || (this.cop_change > 0 ? this.cop_change : 3200)
      const usdInCop = (parseFloat(this.changeGiven.usd) || 0) * rateCashUsd
      const copVal = parseFloat(this.changeGiven.cop) || 0
      const bsInCop = (parseFloat(this.changeGiven.bs) || 0) * (parseFloat(this.effectiveRateCopBs) || 0)
      return Math.round(usdInCop + copVal + bsInCop)
    }
  },
  methods: {
    getTotal() {
      let total = 0
      this.cart.forEach((product) => {
        total += product.price * product.quantity
      })
      return total.toFixed(2)
    },
    getTotalCop() {
      let total = 0
      this.cart.forEach((product) => {
        total += product.price_cop * product.quantity
      })
      return total.toFixed(2)
    },
    getDiscountAmount() {
      const subtotal = parseFloat(this.getTotal())
      const discountPercentage = parseFloat(this.selectedDiscount)
      const discount = (subtotal * discountPercentage) / 100
      return discount.toFixed(2)
    },
    getTotalWithDiscount() {
      const subtotal = parseFloat(this.getTotal())
      const discount = parseFloat(this.getDiscountAmount())
      const surcharge = parseFloat(this.getSurchargeAmount())
      return (subtotal - discount + surcharge).toFixed(2)
    },
    getSurchargeAmount() {
      const subtotal = parseFloat(this.getTotal())
      const surchargePercentage = this.selectedSurcharge === 'custom' ? parseFloat(this.customSurcharge) : parseFloat(this.selectedSurcharge)
      const surcharge = (subtotal * surchargePercentage) / 100
      return surcharge.toFixed(2)
    },
    getTotalCopWithDiscount() {
      const subtotal = parseFloat(this.getTotalCop())
      const discountPercentage = parseFloat(this.selectedDiscount)
      const discount = (subtotal * discountPercentage) / 100
      const surchargePercentage = this.selectedSurcharge === 'custom' ? parseFloat(this.customSurcharge) : parseFloat(this.selectedSurcharge)
      const surcharge = subtotal * surchargePercentage / 100
      const total = subtotal - discount + surcharge
      // Redondeo de 100 en 100 para Pesos Colombianos
      return (Math.round(total / 100) * 100).toFixed(2)
    },
    back() {
      if ((this.mode = 'cart')) {
      }

      if ((this.mode = 'client')) {
        this.mode = 'cart'
      }
    },
    next() {
      if (this.mode == 'cart') {
        if (this.cart.length == 0) {
          return alert('No puede continuar sin escoger un producto')
        }

        // Validate decimal quantities
        for (let product of this.cart) {
          if (!this.validateQuantity(product, product.quantity)) {
            return alert(`El producto ${product.name} no permite cantidades decimales`)
          }
        }

        if (this.withoutClient) {
          this.form.client = {
            name: 'Cliente por defecto',
            email: null,
            phone: '0414409888391',
            address: 'San diego',
            identification: '0000',
            balance: 0,
            typeClient: 'a',
            companyName: null,
            id: 1,
          }
          this.form.products = this.cart
          this.form.discount = {
            type: 'percentage',
            value: parseFloat(this.selectedDiscount)
          }
          this.form.surcharge = {
            type: 'percentage',
            value:  this.selectedSurcharge === 'custom' ? parseFloat(this.customSurcharge) : parseFloat(this.selectedSurcharge)
          }

          return this.openPaymentModal()
        }
        this.mode = 'client'
      } else if (this.mode == 'client') {
        // Validate decimal quantities again before proceeding
        for (let product of this.cart) {
          if (!this.validateQuantity(product, product.quantity)) {
            return alert(`El producto ${product.name} no permite cantidades decimales`)
          }
        }

        if (!this.form.client || !this.form.client.name) {
          return alert('Por favor complete los datos del cliente')
        }

        this.form.products = this.cart
        this.form.discount = {
          type: 'percentage',
          value: parseFloat(this.selectedDiscount)
        }
        this.form.surcharge = {
          type: 'percentage',
          value: this.isSurchargeVisible ? (this.selectedSurcharge === 'custom' ? parseFloat(this.customSurcharge) : parseFloat(this.selectedSurcharge)) : 0
        }

        this.openPaymentModal()
      } else if (this.mode == 'pay') {
        this.mode = 'print'
      }
    },
    removeProduct(product) {
      if (confirm('Estas seguro que quieres eliminar este item?')) {
        let products = this.cart
        let newProducts = products.filter((prd) => prd.id != product.id)
        this.cart = newProducts
      }
    },
    addCart(product) {
      if (product.quantity <= 0) {
        return alert('No hay stock de este producto')
      }

      const priceUsd = product.prices && product.prices.length > 0 ? parseFloat(product.prices[0].price) : 0
      const priceCop = product.price_cop && parseFloat(product.price_cop) > 0
        ? parseFloat(product.price_cop)
        : (priceUsd * (this.cop_change || 1))

      let enabled = true // Para saber si ya existe el producto
      this.cart.forEach((prd) => {
        if (prd.id == product.id) {
          enabled = false
          prd.quantity += 1
        }
      })
      if (enabled) {
        this.cart.push({
          ...product,
          stock: product.quantity,
          is_decimal: product.is_decimal,
          quantity: 1,
          price: priceUsd,
          price_cop: priceCop,
          quick: false
        })
      }
    },
    validateQuantity(product, quantity) {
      if (!product.is_decimal && quantity % 1 !== 0) {
        return false
      }
      return true
    },
    validateAndUpdateQuantity(product, key, event) {
      const quantity = parseFloat(event.target.value)

      // Check for negative values
      if (quantity < 0) {
        alert('No se puede vender cantidades negativas')
        this.cart[key]['quantity'] = 0
        event.target.value = 0
        return
      }

      // Check for decimal validation
      if (!this.validateQuantity(product, quantity)) {
        alert('Este producto no permite cantidades decimales')
        // Reset to integer value
        this.cart[key]['quantity'] = Math.floor(quantity)
        event.target.value = Math.floor(quantity)
      }
    },
    onSearchProductsChange() {
      this.$inertia.get('/pos', pickBy({ search: this.form.search }), {
        preserveState: true,
        preserveScroll: true,
        replace: true,
      })
    },
    handleRegisterOpened() {
      window.location.reload()
    },

    findClient() {
      this.$inertia.get('/pos', pickBy(this.form), { preserveState: true })

      setTimeout(() => {
        if (this.client) {
          this.textSearch = 'Buscar cliente'
          this.showClientCreate = true
          this.form.client = {
            name: this.client.name,
            email: this.client.email,
            phone: this.client.phone,
            address: this.client.address,
            identification: this.client.identification,
            balance: this.client.balance,
            typeClient: this.client.typeClient,
            companyName: this.client.companyName,
          }
        } else {
          alert('No se encontro cliente, puede crearlo en el siguiente formulario')
          this.showClientCreate = true
        }
      }, 1500)
    },
    isCashMethod(method) {
      if (!method) return false
      const m = method.toLowerCase()
      return m.includes('efectivo') || m.includes('cash')
    },

    openPaymentModal() {
      if (!this.user_cash_register) {
        alert('Debes aperturar tu caja registradora para poder cobrar.')
        return
      }

      this.paymentTab = null // Sin moneda seleccionada por defecto

      this.singlePay = {
        method: null,
        amountGiven: 0,
        reference: '',
      }

      this.changeGiven = {
        usd: 0,
        cop: 0,
        bs: 0,
        customized: false,
      }

      const defaultUsd = this.methodsUsd.length ? this.methodsUsd[0].name : 'Zelle'
      const puntoMethod = this.methodsBs.find(m => (m.name || '').toLowerCase().includes('punto'))
      const defaultBs = puntoMethod ? puntoMethod.name : (this.methodsBs.length ? this.methodsBs[0].name : 'Punto de Venta')
      const copCash = this.methodsCop.find(m => (m.name || '').toLowerCase().includes('efectivo'))
      const defaultCop = copCash ? copCash.name : (this.methodsCop.length ? this.methodsCop[0].name : 'Efectivo Pesos (COP)')
      const copTransferMethod = this.methodsCop.find(m => {
        const name = (m.name || '').toLowerCase()
        return name.includes('transf') || name.includes('bancolombia') || name.includes('nequi')
      })
      const defaultCopTransfer = copTransferMethod ? copTransferMethod.name : 'Transferencia COP'

      this.mixedPay = {
        usd_cash: { enabled: true, amount: 0, method: 'Efectivo Dolar', reference: '' },
        usd: { enabled: false, amount: 0, method: defaultUsd, reference: '' },
        bs: { enabled: false, amount: 0, method: defaultBs, reference: '' },
        cop: { enabled: false, amount: 0, method: defaultCop, reference: '' },
        cop_transfer: { enabled: false, amount: 0, method: defaultCopTransfer, reference: '' },
      }

      this.showPaymentModal = true
    },

    closePaymentModal() {
      this.showPaymentModal = false
    },

    selectPaymentTab(tab) {
      this.paymentTab = tab
      this.singlePay.reference = ''
      this.changeGiven = {
        usd: 0,
        cop: 0,
        bs: 0,
        customized: false,
      }

      if (tab === 'cash_usd') {
        this.singlePay.method = 'Efectivo Dolar'
        this.singlePay.amountGiven = this.totalCashUsd
      } else if (tab === 'ref_usd' || tab === 'usd') {
        const refMethod = this.methodsUsd.find(m => (m.name || '').toLowerCase().includes('zelle')) || (this.methodsUsd.length ? this.methodsUsd[0] : null)
        this.singlePay.method = refMethod ? refMethod.name : 'Zelle'
        this.singlePay.amountGiven = this.totalUsd
      } else if (tab === 'bs') {
        const puntoMethod = this.methodsBs.find(m => (m.name || '').toLowerCase().includes('punto'))
        const bsMethod = puntoMethod ? puntoMethod.name : (this.methodsBs.length ? this.methodsBs[0].name : 'Punto de Venta')
        this.singlePay.method = bsMethod
        this.singlePay.amountGiven = this.totalBs
      } else if (tab === 'cop') {
        // Por defecto Efectivo Pesos (COP) como solicita el cliente
        const copCash = this.methodsCop.find(m => (m.name || '').toLowerCase().includes('efectivo'))
        this.singlePay.method = copCash ? copCash.name : 'Efectivo Pesos (COP)'
        this.singlePay.amountGiven = this.totalCop
      }
    },

    setChangeAll(currency) {
      this.changeGiven.customized = true
      if (currency === 'cop') {
        this.changeGiven.cop = this.activeTotalVueltoCop
        this.changeGiven.usd = 0
        this.changeGiven.bs = 0
      } else if (currency === 'usd') {
        this.changeGiven.usd = this.activeTotalVueltoUsd
        this.changeGiven.cop = 0
        this.changeGiven.bs = 0
      } else if (currency === 'bs') {
        this.changeGiven.bs = this.activeTotalVueltoBs
        this.changeGiven.usd = 0
        this.changeGiven.cop = 0
      }
    },

    completeRemainingChangeCop() {
      this.changeGiven.customized = true
      const rateCashUsd = parseFloat(this.cashDollarRate) || (this.cop_change > 0 ? this.cop_change : 3200)
      const usdInCop = (parseFloat(this.changeGiven.usd) || 0) * rateCashUsd
      const bsInCop = (parseFloat(this.changeGiven.bs) || 0) * (parseFloat(this.effectiveRateCopBs) || 0)
      const alreadyInCop = usdInCop + bsInCop
      const diff = Math.max(0, this.activeTotalVueltoCop - alreadyInCop)
      this.changeGiven.cop = Math.round(diff)
    },

    fillRemainingCashUsd() {
      this.mixedPay.usd_cash.enabled = true
      const rem = Math.max(0, this.mixedRemainingCashUsd)
      this.mixedPay.usd_cash.amount = parseFloat(((parseFloat(this.mixedPay.usd_cash.amount) || 0) + rem).toFixed(2))
    },

    fillRemainingUsd() {
      this.mixedPay.usd.enabled = true
      const rem = Math.max(0, this.mixedRemainingUsd)
      this.mixedPay.usd.amount = parseFloat(((parseFloat(this.mixedPay.usd.amount) || 0) + rem).toFixed(2))
    },

    fillRemainingBs() {
      this.mixedPay.bs.enabled = true
      const rem = Math.max(0, this.mixedRemainingBs)
      this.mixedPay.bs.amount = parseFloat(((parseFloat(this.mixedPay.bs.amount) || 0) + rem).toFixed(2))
    },

    fillRemainingCop() {
      this.mixedPay.cop.enabled = true
      const rem = Math.max(0, this.mixedRemainingCop)
      this.mixedPay.cop.amount = Math.round(((parseFloat(this.mixedPay.cop.amount) || 0) + rem) / 100) * 100
    },

    fillRemainingCopTransfer() {
      this.mixedPay.cop_transfer.enabled = true
      const rem = Math.max(0, this.mixedRemainingCop)
      this.mixedPay.cop_transfer.amount = Math.round(((parseFloat(this.mixedPay.cop_transfer.amount) || 0) + rem) / 100) * 100
    },

    processPaymentAndSubmit() {
      if (!this.paymentTab) {
        return alert('Por favor, selecciona una forma de pago antes de continuar.')
      }

      if (this.paymentTab !== 'mixed' && !this.singlePay.method) {
        return alert('Por favor, selecciona el método de pago correspondiente.')
      }

      const totalUsd = this.totalUsd
      const totalBs = this.totalBs
      const totalCop = this.totalCop
      let payments = []

      if (this.paymentTab === 'cash_usd') {
        const given = parseFloat(this.singlePay.amountGiven) || 0
        if (given <= 0) {
          return alert('Debe ingresar un monto válido a pagar en dólares en efectivo')
        }
        if (given < (this.totalCashUsd - 0.05) && !confirm(`El monto ingresado ($${given.toFixed(2)}) es menor al total en efectivo ($${this.totalCashUsd.toFixed(2)}). ¿Desea procesar como venta a crédito/saldo pendiente?`)) {
          return
        }
        payments.push({
          method: 'Efectivo Dolar',
          amount: given,
          amount_bs: 0,
          amount_cop: 0,
          reference: null,
        })
      } else if (this.paymentTab === 'ref_usd' || this.paymentTab === 'usd') {
        const given = parseFloat(this.singlePay.amountGiven) || 0
        if (given <= 0) {
          return alert('Debe ingresar un monto válido a pagar en dólares')
        }
        if (given < (totalUsd - 0.05) && !confirm(`El monto ingresado ($${given.toFixed(2)}) es menor al total ($${totalUsd.toFixed(2)}). ¿Desea procesar como venta a crédito/saldo pendiente?`)) {
          return
        }
        payments.push({
          method: this.singlePay.method || 'Zelle',
          amount: Math.min(given, totalUsd),
          amount_bs: 0,
          amount_cop: 0,
          reference: this.singlePay.reference || null,
        })
      } else if (this.paymentTab === 'bs') {
        const given = parseFloat(this.singlePay.amountGiven) || 0
        if (given <= 0) {
          return alert('Debe ingresar un monto válido a pagar en bolívares')
        }
        if (given < (totalBs - 0.5) && !confirm(`El monto ingresado (Bs. ${this.formatCurrency(given)}) es menor al total (Bs. ${this.formatCurrency(totalBs)}). ¿Desea procesar como venta a crédito/saldo pendiente?`)) {
          return
        }
        const paidUsd = this.change > 0 ? parseFloat((given / this.change).toFixed(2)) : totalUsd
        payments.push({
          method: this.singlePay.method || 'Pago Móvil',
          amount: Math.min(paidUsd, totalUsd),
          amount_bs: given,
          amount_cop: 0,
          reference: this.singlePay.reference || null,
        })
      } else if (this.paymentTab === 'cop') {
        const given = parseFloat(this.singlePay.amountGiven) || 0
        if (given <= 0) {
          return alert('Debe ingresar un monto válido a pagar en pesos (COP)')
        }
        if (given < (totalCop - 100) && !confirm(`El monto ingresado (COP ${this.formatCurrency(given)}) es menor al total (COP ${this.formatCurrency(totalCop)}). ¿Desea procesar como venta a crédito/saldo pendiente?`)) {
          return
        }
        const paidUsd = this.rateCop > 0 ? parseFloat((given / this.rateCop).toFixed(2)) : totalUsd
        payments.push({
          method: this.singlePay.method || 'Efectivo Pesos (COP)',
          amount: Math.min(paidUsd, totalUsd),
          amount_bs: 0,
          amount_cop: given,
          reference: this.singlePay.reference || null,
        })
      } else if (this.paymentTab === 'mixed') {
        if (this.mixedRemainingCop > 50 && !confirm(`Aún resta un saldo de COP ${this.formatCurrency(this.mixedRemainingCop)} por cubrir. ¿Desea continuar con saldo pendiente?`)) {
          return
        }

        if (this.mixedPay.usd_cash && this.mixedPay.usd_cash.enabled && parseFloat(this.mixedPay.usd_cash.amount) > 0) {
          const cashUsdVal = parseFloat(this.mixedPay.usd_cash.amount)
          payments.push({
            method: 'Efectivo Dolar',
            amount: cashUsdVal,
            amount_bs: 0,
            amount_cop: 0,
            reference: this.mixedPay.usd_cash.reference || null,
          })
        }

        if (this.mixedPay.usd && this.mixedPay.usd.enabled && parseFloat(this.mixedPay.usd.amount) > 0) {
          payments.push({
            method: this.mixedPay.usd.method || 'Zelle',
            amount: parseFloat(this.mixedPay.usd.amount),
            amount_bs: 0,
            amount_cop: 0,
            reference: this.mixedPay.usd.reference || null,
          })
        }

        if (this.mixedPay.bs.enabled && parseFloat(this.mixedPay.bs.amount) > 0) {
          const bsVal = parseFloat(this.mixedPay.bs.amount)
          const equivUsd = this.change > 0 ? parseFloat((bsVal / this.change).toFixed(2)) : 0
          payments.push({
            method: this.mixedPay.bs.method || 'Pago Móvil',
            amount: equivUsd,
            amount_bs: bsVal,
            amount_cop: 0,
            reference: this.mixedPay.bs.reference || null,
          })
        }

        if (this.mixedPay.cop.enabled && parseFloat(this.mixedPay.cop.amount) > 0) {
          const copVal = parseFloat(this.mixedPay.cop.amount)
          const equivUsd = this.rateCop > 0 ? parseFloat((copVal / this.rateCop).toFixed(2)) : 0
          payments.push({
            method: this.mixedPay.cop.method || 'Efectivo Pesos (COP)',
            amount: equivUsd,
            amount_bs: 0,
            amount_cop: copVal,
            reference: this.mixedPay.cop.reference || null,
          })
        }

        if (this.mixedPay.cop_transfer && this.mixedPay.cop_transfer.enabled && parseFloat(this.mixedPay.cop_transfer.amount) > 0) {
          const copTransVal = parseFloat(this.mixedPay.cop_transfer.amount)
          const equivUsd = this.rateCop > 0 ? parseFloat((copTransVal / this.rateCop).toFixed(2)) : 0
          payments.push({
            method: this.mixedPay.cop_transfer.method || 'Transferencia COP',
            amount: equivUsd,
            amount_bs: 0,
            amount_cop: copTransVal,
            reference: this.mixedPay.cop_transfer.reference || null,
          })
        }

        if (payments.length === 0) {
          return alert('Debe habilitar al menos una moneda e ingresar el monto pagado')
        }
      }

      let finalChangeGiven = {
        usd: parseFloat(this.changeGiven.usd) || 0,
        cop: parseFloat(this.changeGiven.cop) || 0,
        bs: parseFloat(this.changeGiven.bs) || 0,
      }
      if (this.hasActiveVuelto && (finalChangeGiven.usd === 0 && finalChangeGiven.cop === 0 && finalChangeGiven.bs === 0)) {
        finalChangeGiven.cop = this.activeTotalVueltoCop
      }

      if (!this.user_cash_register) {
        alert('Debes aperturar tu caja registradora para poder facturar.')
        return
      }

      this.form.change_given = finalChangeGiven
      this.form.payments = payments
      this.form.cash_register_id = this.user_cash_register.id
      this.check = true
      this.showPaymentModal = false
      this.form.post('/orders')
    },

    formatCurrency(value) {
      return new Intl.NumberFormat('es-VE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value || 0)
    },

    formatCurrencyBs(value) {
      return new Intl.NumberFormat('es-VE', {
        style: 'currency',
        currency: 'VEF'
      }).format(value || 0)
    }
  },
  mounted() {
    this.check = false
    const searchEl = document.getElementById('search')
    if (searchEl) searchEl.focus()
    window.addEventListener('keyup', (event) => {
      if ((event.keyCode === 120 || event.key === 'F9') && !this.check) {
        if (this.showPaymentModal) {
          this.processPaymentAndSubmit()
        } else {
          this.next()
        }
      }
    });
  }
}
</script>
